import * as React from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { SelectChangeEvent, Typography } from "@mui/material";
import { Grid,Card,Paper,Alert } from '@mui/material'
import {IDPoolContext} from "../Context/IDContext";
import {useContext, useEffect} from "react";

export function DeviceTypeSelector() {

    const {
        deviceType,
        updateDeviceType,
        poolDeviceCount,
        loading,
        deviceTypes,
        error } = useContext(IDPoolContext)

    const handleChange = (event: SelectChangeEvent<unknown>) => {
    if (updateDeviceType)
        updateDeviceType(event.target.value as string);
    };

    return (
    <div>
    {loading && <Alert severity="info">Waiting for Server</Alert>}
    {error && <Alert severity="error">{error}</Alert>}
    {!error &&
        <div>
            <Paper elevation={3} sx={{mt:1,p:5}}>
                <Grid container spacing={2}>
                    <Grid item xs={6}>
                        <FormControl sx={{ m: 1, minWidth: 120 }}>
                            <InputLabel id="demo-simple-select-helper-label">Device Type</InputLabel>
                            <Select
                                labelId="demo-simple-select-helper-label"
                                id="demo-simple-select-helper"
                                value={deviceType}
                                label="Device Type"
                                onChange={handleChange}
                            >
                            {deviceTypes?deviceTypes.map((dt) => {
                                return(<MenuItem key={dt.deviceType} value={dt.deviceType}>{dt.deviceType}</MenuItem>)
                            }):<></>}
                            
                            </Select>
                        
                            <FormHelperText>Currently Manufacturing</FormHelperText>
                        </FormControl>
                </Grid>
                <Grid item xs={6}>
                    <Card>
                        <Typography variant="h5" align="center">Number of Serials Remaining</Typography>
                        <Typography variant="h2"  align="center">{ poolDeviceCount?.pool?.[1].deviceCount?.[deviceType]?? 0}</Typography>
                    </Card>
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <Typography variant="h6" align="center">Pending</Typography>
                            <Typography variant="h5"  align="center">{poolDeviceCount?.pool?.[2].deviceCount?.[deviceType]?? 0}</Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography variant="h6" align="center">Used</Typography>
                            <Typography variant="h5" align="center">{poolDeviceCount?.pool?.[0].deviceCount?.[deviceType]?? 0}</Typography>
                        </Grid>
                    </Grid>
                </Grid>
                </Grid>  
        </Paper>
        </div>
    }
    </div>
  );
}

